// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3bK0F","info":"Note_info__3k1Kv","note":"Note_note__3RU2H","actions":"Note_actions__2IcR8"};